<template>
    <div>
        <div class="detail-container">
            <p class="nav">
                <span class="to-left" @click="waybillSearch()">
                    <icon name="to-left"></icon>
                </span>
                <span class="title">运单信息</span>
            </p>
            <p class="new-tencentCaptcha-tip">
                为提升用户体验，系统将采用新版腾讯滑块验证码。如果滑块验证码功能异常，
                请确认访问下面的网站（turing.captcha.qcloud.com）是否正常。感谢你的理解和支持。
            </p>
            <div v-if="showWaybillDetail">
                <div v-for="item in waybillNoList" :key="item" class="list-item">
                    <div
                        v-if="
                            (waybillModel(item) && isAbroadRoute(waybillModel(item).routes)) ||
                            (waybillModel(item) &&
                                waybillModel(item).routes &&
                                waybillModel(item).routes.length > 0 &&
                                !isAbroadRoute(waybillModel(item).routes) &&
                                waybillModel(item).originOld &&
                                waybillModel(item).destinationOld)
                        "
                    >
                        <waybill-info
                            :waybillModel="waybillModel(item)"
                            :getStatusByOpcode="getStatusByOpcode(waybillModel(item).routes[0])"
                        ></waybill-info>
                        <waybill-route :routes="waybillModel(item).routes"></waybill-route>
                        <waybill-child v-if="hasChildSet(waybillModel(item))" :waybillNoList="waybillModel(item).childSet"></waybill-child>
                    </div>
                    <div v-else class="not-found">
                        <p class="title"><span class="text">运单号</span>{{ item }}</p>
                        <p>{{ `运单${item}未揽收或寄件时间超过3个月。` }}</p>
                        <p v-if="isAppleWaybill(item)">如有疑问，可致电顺丰客服热线4001288853</p>
                    </div>
                </div>
            </div>
        </div>
        <!--腾讯验证码-->
        <tencent-captcha ref="tencentCaptcha"></tencent-captcha>
    </div>
</template>

<script>
import waybillChild from './waybill-child'
import tencentCaptcha from '@/components/validation/tencent-captcha'
import rootChildCommon from '@/mixins/waybill/rootChildCommon'
export default {
    name: 'WaybillDetail',
    components: {
        waybillChild,
        tencentCaptcha
    }, // 运单详情页
    mixins: [rootChildCommon],
    data() {
        return {
            waybillNoList: this.$route.params.bno
                .split(',')
                .filter(item => !!item)
                .map(item => item.toLocaleUpperCase()) // 地址栏带过来的运单号列表(如果bno不存在则不会进入该组件)
        }
    },
    mounted() {
        // eslint-disable-next-line no-undef
        if (_webconfig.useTencentCaptcha == true) {
            this.showTencentCaptcha(this.query)
        } else {
            this.query()
        }
    },
    beforeMount() {
        this.$store.commit('setShowHeader', false) // 隐藏公共的头部
    },
    methods: {
        // 调用腾讯验证码
        showTencentCaptcha(callback, fetchData = this.waybillNoList) {
            this.$refs.tencentCaptcha.getCaptcha(callback, fetchData)
        },
        // 返回
        waybillSearch() {
            this.$router.push({ name: 'WaybillSearch' })
        },
        // 是否有子单
        hasChildSet(model) {
            return model.childSet && model.childSet.length > 0
        },
        isAppleWaybill(waybillNo) {
            const no = waybillNo.toString()
            return no.startsWith('960') || no.startsWith('SF960')
        }
    }
}
</script>

<style lang="scss" scoped>
.detail-container {
    padding: 0 20px 40px;
}
.list-item {
    &:not(:last-of-type) {
        border-bottom: 2px solid $gray-lighter;
        margin-bottom: 70px;
    }
}
.nav {
    height: 80px;
    line-height: 80px;
    margin: 20px 0 40px;
    position: relative;
    text-align: center;
    .to-left {
        left: 0;
        position: absolute;
        .icon-to-left {
            width: 40px;
        }
    }
    .title {
        font-size: 40px;
    }
}

.new-tencentCaptcha-tip {
    font-size: 12px;
    padding: 15px 25px;
    background-color: #f2f2f2;
    color: #dc1e32;
    border-radius: 4px;
    margin-bottom: 10px;
}
.loading-wrapper {
    text-align: center;
    margin-top: 40%;
    color: $white;
    .loading-more {
        display: inline-block;
    }
}
.not-found {
    background: $bg-color;
    color: $gray;
    font-size: 25px;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
    .title {
        .text {
            margin-right: 15px;
        }
        font-size: 35px;
        color: $black;
        margin-bottom: 35px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/waybill/waybillDetail/index.vue